import { createContext, FC, memo, useContext } from 'react';

import { LocaleCode } from '@locale/locale-store';

const LocaleContext = createContext<LocaleCode | undefined>(undefined);

export const useLocaleContext = () => useContext(LocaleContext);

type OverrideLocaleContextProps = {
  locale?: LocaleCode;
};

export const OverrideLocaleContext: FC<OverrideLocaleContextProps> = memo(
  ({ locale, children }) => {
    return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
  },
);
